module.exports = __webpack_public_path__ + "img/download-white.46cdf26c.svg";